module.exports = __webpack_public_path__ + "img/behold-5.2d29a96f.png";